/**
 * Created by DejanK on 10/13/2016.
 */
import './home-page.scss'
import { noop } from 'lodash'
import HTML from './home-page.html'

export { noop as Controller, HTML }
